import { Button, Modal, ModalBody, ModalFooter, Col, Row } from "reactstrap";

import "./ModalComponent.css";
import { useContext, useEffect, useRef, useState } from "react";
import { DocumentTypeContext } from "../../context/DocumentContext";
import SignatureCanvas from "react-signature-canvas";
import { UserTypeContext } from "../../context/UserTypeContext";
import { useToast } from "../../context/ToastContext";
import { FaUpload, FaTrashAlt } from "react-icons/fa";
import { FaCamera } from "react-icons/fa";
import InputMask from "react-input-mask";

interface ModalComponentProps {
  openModal: boolean;
  closeModal: () => void;
}

const ModalComponent = (props: ModalComponentProps) => {
  const { openModal, closeModal } = props;
  const { formValuesSign, setFormValuesSign, createSignUser, signers } =
    useContext(DocumentTypeContext);
  const showToast = useToast();

  const { formValuesUsers, ipUser } = useContext(UserTypeContext);
  const [selectedSignature, setSelectedSignature] = useState<{
    fontFamily: string;
  } | null>(null);

  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [signing, setSigning] = useState(false);

  const sigCanvas = useRef({});

  const clear = () => {
    //@ts-ignore
    sigCanvas.current.clear();
    setSelectedSignature(null);
  };

  const handleBlur = (valueAtt: any, name: string) => {
    setFormValuesSign({
      ...formValuesSign,
      [name]: valueAtt,
    });
  };

  const saveSignature = async () => {
    if (!formValuesSign?.nationalRegisterCode) {
      showToast("info", "Informe o documento");
      return;
    }

    let dataURL;

    if (selectedSignature) {
      const tempCanvas = document.createElement("canvas");
      const tempContext = tempCanvas.getContext("2d");

      if (tempContext) {
        tempCanvas.width = 500;
        tempCanvas.height = 200;

        tempContext.clearRect(0, 0, tempCanvas.width, tempCanvas.height);
        tempContext.fillStyle = "#000";
        tempContext.textAlign = "center";
        tempContext.textBaseline = "middle";

        let fontSize = 80;
        tempContext.font = `${fontSize}px ${selectedSignature.fontFamily}`;

        const name = formValuesUsers.name;
        const words = name.split(" ");
        let lines = [];
        let currentLine = "";

        for (let word of words) {
          let testLine = currentLine + word + " ";
          let testWidth = tempContext.measureText(testLine).width;

          if (testWidth > tempCanvas.width - 40 && currentLine.length > 0) {
            lines.push(currentLine);
            currentLine = word + " ";
          } else {
            currentLine = testLine;
          }
        }
        lines.push(currentLine.trim());

        while (lines.length * fontSize > tempCanvas.height - 20) {
          fontSize -= 2;
          tempContext.font = `${fontSize}px ${selectedSignature.fontFamily}`;
        }

        let y =
          (tempCanvas.height - lines.length * fontSize) / 2 + fontSize / 2;
        for (let line of lines) {
          tempContext.fillText(line.trim(), tempCanvas.width / 2, y);
          y += fontSize;
        }

        dataURL = tempCanvas.toDataURL("image/png");
        console.log("dataURL", dataURL);
      } else {
        console.error("Falha ao obter contexto 2D do canvas");
        return;
      }
    } else {
      //@ts-ignore
      dataURL = sigCanvas.current.getTrimmedCanvas().toDataURL("image/png");
      console.log("dataURL", dataURL);
    }

    try {
      setSigning(true);
      await createSignUser(dataURL, selectedImage);
      closeModal();
    } catch (error) {
      console.error("Erro ao criar assinatura:", error);
    } finally {
      setSigning(false);
    }
  };

  const fontStyles = [
    { fontFamily: "'Dancing Script'" },
    { fontFamily: "'Pacifico'" },
    { fontFamily: "'Great Vibes'" },
  ];

  const applySignatureToCanvas = (style: any) => {
    setSelectedSignature(style);

    //@ts-ignore
    const canvas = sigCanvas.current.getCanvas();
    const context = canvas.getContext("2d");

    canvas.width = window.innerWidth < 500 ? 300 : 500;
    canvas.height = 150;

    context.clearRect(0, 0, canvas.width, canvas.height);
    context.fillStyle = "black";
    context.textAlign = "center";
    context.textBaseline = "middle";

    let fontSize = 60;
    context.font = `${fontSize}px ${style.fontFamily}`;

    let words = formValuesUsers.name.split(" ");
    let lines = [];
    let currentLine = "";

    for (let word of words) {
      let testLine = currentLine + word + " ";
      let testWidth = context.measureText(testLine).width;

      if (testWidth > canvas.width - 40 && currentLine.length > 0) {
        lines.push(currentLine);
        currentLine = word + " ";
      } else {
        currentLine = testLine;
      }
    }
    lines.push(currentLine);

    while (lines.length * fontSize > canvas.height - 20) {
      fontSize -= 2;
      context.font = `${fontSize}px ${style.fontFamily}`;
    }

    let y = (canvas.height - lines.length * fontSize) / 2 + fontSize / 2;
    for (let line of lines) {
      context.fillText(line.trim(), canvas.width / 2, y);
      y += fontSize;
    }
  };

  const base64ToByteArray = (base64: string) => {
    const binaryString = atob(base64);
    const byteArray = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      byteArray[i] = binaryString.charCodeAt(i);
    }
    return Array.from(byteArray);
  };

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setPreviewUrl(URL.createObjectURL(file));

      const reader = new FileReader();
      reader.onloadend = () => {
        if (reader.result) {
          const base64String = reader.result.toString().split(",")[1];
          const byteArray = base64ToByteArray(base64String);
          //@ts-ignore
          setSelectedImage(byteArray);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setIsDragging(false);
    const file = event.dataTransfer.files[0];

    if (file) {
      setPreviewUrl(URL.createObjectURL(file));

      const reader = new FileReader();
      reader.onloadend = () => {
        if (reader.result) {
          const base64String = reader.result.toString().split(",")[1];
          const byteArray = base64ToByteArray(base64String);
          //@ts-ignore
          setSelectedImage(byteArray);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const clearImage = () => {
    setSelectedImage(null);
    setPreviewUrl(null);
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleFileUpload = () => {
    const fileInput = document.getElementById("fileInput") as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  };

  const foundSigner = signers?.find(
    (x: any) => x.name === formValuesUsers.email
  );
  console.log("foundSigner", foundSigner);
  useEffect(() => {
    setIsMobile(/Mobi|Android/i.test(navigator.userAgent));
  });

  return (
    <Modal
      isOpen={openModal}
      toggle={closeModal}
      className="modal-content"
      style={{ maxWidth: "600px", borderRadius: "10px" }}
    >
      <div className="modal-header text-center">
        <h4 className="w-100" style={{ fontWeight: "bold", color: "#333" }}>
          Assinar Documento
        </h4>
      </div>

      <ModalBody style={{ position: "relative" }}>
        {signing && (
          <div
            style={{
              position: "absolute",
              inset: 0,
              background: "rgba(255,255,255,0.85)",
              zIndex: 10,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 12,
              borderRadius: 8,
            }}
          >
            <div
              style={{
                width: 40,
                height: 40,
                border: "4px solid #e0e0e0",
                borderTop: "4px solid #F9B233",
                borderRadius: "50%",
                animation: "spin 0.8s linear infinite",
              }}
            />
            <span style={{ color: "#555", fontWeight: 500, fontSize: 14 }}>
              Processando assinatura...
            </span>
          </div>
        )}
        <Row className="text-center mb-3">
          <Col>
            <strong>Nome:</strong> {formValuesUsers.name}
          </Col>
          <Col>
            <strong>Email:</strong> {formValuesUsers.email}
          </Col>
          <Col>
            <strong>IP:</strong> {ipUser}
          </Col>
        </Row>

        <div className="mb-3">
          <label className="form-label">
            <strong>CPF: </strong>
          </label>
          <InputMask
            mask="999.999.999-99"
            value={formValuesSign?.nationalRegisterCode}
            onChange={(e) => handleBlur(e.target.value, "nationalRegisterCode")}
            className="form-control"
            name="nationalRegisterCode"
            type="text"
          />
        </div>

        {foundSigner?.requireSignerDocument && (
          <>
            <div className="mb-3">
              <label className="form-label">
                <strong>Enviar Documento (Imagem)</strong>
              </label>

              <div
                className="upload-box"
                onClick={handleFileUpload}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                style={{
                  border: isDragging ? "2px dashed #FFA500" : "2px dashed #ccc",
                  borderRadius: "8px",
                  padding: "15px",
                  textAlign: "center",
                  backgroundColor: isDragging ? "#FFF3E0" : "#f9f9f9",
                  cursor: "pointer",
                  transition: "0.3s",
                }}
              >
                <FaUpload size={24} color="#FFA500" />
                <p style={{ fontSize: "14px", marginTop: "5px" }}>
                  {isDragging
                    ? "Solte a imagem aqui..."
                    : "Clique ou arraste um arquivo para enviar"}
                </p>

                <input
                  type="file"
                  accept="image/*"
                  id="fileInput"
                  onChange={handleImageChange}
                  style={{ display: "none" }}
                />
              </div>
            </div>

            {previewUrl && (
              <div className="text-center">
                <p style={{ fontSize: "14px", fontWeight: "bold" }}>
                  Prévia da Imagem
                </p>
                <div style={{ position: "relative", display: "inline-block" }}>
                  <img
                    src={previewUrl}
                    alt="Prévia do Documento"
                    style={{
                      maxWidth: "100%",
                      height: "150px",
                      borderRadius: "8px",
                      border: "1px solid #ddd",
                      padding: "5px",
                    }}
                  />
                  <button
                    onClick={clearImage}
                    style={{
                      position: "absolute",
                      top: "-10px",
                      right: "-10px",
                      background: "#FF5252",
                      color: "white",
                      border: "none",
                      borderRadius: "50%",
                      width: "30px",
                      height: "30px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
                    }}
                  >
                    <FaTrashAlt size={14} />
                  </button>
                </div>
              </div>
            )}
          </>
        )}

        <div className="text-center mt-3">
          <p style={{ fontWeight: "bold", fontSize: "14px" }}>
            Escolha um estilo de assinatura
          </p>
          <div
            className="d-flex justify-content-center"
            style={{ gap: "50px" }}
          >
            {fontStyles.map((style, index) => (
              <div
                key={index}
                onClick={() => {
                  applySignatureToCanvas(style);
                  setSelectedSignature(style);
                }}
                style={{
                  ...style,
                  border:
                    selectedSignature === style
                      ? "2px solid #DF8E25"
                      : "2px solid #ccc",
                  padding: "10px",
                  cursor: "pointer",
                  minWidth: "80px",
                  textAlign: "center",
                  transition: "0.2s",
                  borderRadius: "5px",
                }}
              >
                {formValuesUsers.name}
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-3">
          <p style={{ fontWeight: "bold", fontSize: "14px" }}>Assinatura</p>
          <div className="signature-box">
            <SignatureCanvas
              //@ts-ignore
              ref={sigCanvas}
              penColor="black"
              canvasProps={{
                width: 500,
                height: 150,
                className: "signatureCanvas",
              }}
            />
          </div>
          <Button onClick={clear} color="secondary" size="sm" className="mt-2">
            Limpar Assinatura
          </Button>
        </div>
      </ModalBody>

      <ModalFooter
        className="d-flex justify-content-between"
        style={{ flexWrap: "nowrap" }}
      >
        <Button
          className="button-login"
          onClick={saveSignature}
          disabled={signing}
          block
        >
          {signing ? (
            <span style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
              <span
                style={{
                  width: 18,
                  height: 18,
                  border: "2px solid rgba(255,255,255,0.3)",
                  borderTop: "2px solid #fff",
                  borderRadius: "50%",
                  animation: "spin 0.8s linear infinite",
                  display: "inline-block",
                }}
              />
              Assinando...
            </span>
          ) : (
            "ASSINAR"
          )}
        </Button>
        <Button color="secondary" onClick={closeModal} disabled={signing} block>
          Cancelar
        </Button>
      </ModalFooter>

      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </Modal>
  );
};

export default ModalComponent;
